'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { dataTestIds } from 'pdp/src/constants/dataTestIds/dataTestIds'
import { useColors } from 'pdp/src/contexts/ColorsProvider/ColorsProvider'
import { useSizes } from 'pdp/src/contexts/SizesProvider/SizesProvider'
import { cx } from 'utils/cx'

import { SizeDisclaimer } from '../SizeDisclaimer/SizeDisclaimer'
import { ITEM_SIZES, SizeItem } from '../SizeItem/SizeItem'
import { SizesList } from '../SizesList/SizesList'

import fukkuClasses from '@fukku/styles/classes.module.scss'
import styles from './SizesAccordion.module.scss'

type SizesAccordionProps = {
	readonly className?: string
}

export function SizesAccordion({
	className,
}: SizesAccordionProps): React.ReactNode {
	const { t } = useLabels()

	const { selectedColor } = useColors()
	const { selectedSize, isUniqueSize } = useSizes()

	return (
		<div className={styles.sizesAccordionContainer}>
			<SizeDisclaimer
				disclaimer={selectedColor.disclaimer}
				className={styles.sizeDisclaimer}
			/>
			<div
				className={cx(className, styles.sizesAccordion)}
				id='pdp-size-selector'
				data-testid={dataTestIds['pdp.productInfo.sizeSelector']}
			>
				<p id='pdp.sizesSelector' className={fukkuClasses.srOnly}>
					{t('accessibility.pdp.addSize.selector.noSize')}
				</p>
				{selectedSize && isUniqueSize ? (
					<SizeItem
						size={selectedSize}
						extraInfoLayout='row'
						itemHeight={ITEM_SIZES.ACCORDION}
						isUnique
					/>
				) : (
					<SizesList sizes={selectedColor.sizes} selectedSize={selectedSize} />
				)}
			</div>
		</div>
	)
}
